module.exports = __webpack_public_path__ + "img/leagues_sprites.6ef7d061.png";